import { AuthVersionEnum } from "../types";

export const versionHeaderKeys = {
  default: "promofy-token",
  v0: {
    bearerAddress: "promofy-token",
  },
  v1: {
    bearerAddress: "promofy-token",
  },
};

export const authVersions = {
  0: AuthVersionEnum.V0,
  1: AuthVersionEnum.V1,
};
